
//////////////////
export const USER_NEW_SUCCESS = "USER_NEW_SUCCESS";
export const USER_NEW_FAILED = "USER_NEW_FAILED";
///////////////////
export const USER_REMOVE_SUCCESS = "USER_REMOVE_SUCCESS";
export const USER_REMOVE_FAILED = "USER_REMOVE_FAILED";

export const USER_SET_ITEM = "USER_SET_ITEM";


